import { useEffect, useState } from "react";

export default function SplashScreen({ onComplete }: { onComplete: () => void }) {
  const [phase, setPhase] = useState<"enter" | "hold" | "exit">("enter");

  useEffect(() => {
    const holdTimer = setTimeout(() => setPhase("hold"), 600);
    const exitTimer = setTimeout(() => setPhase("exit"), 1800);
    const doneTimer = setTimeout(() => onComplete(), 2600);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-[#f0efef] transition-opacity duration-700 ${
        phase === "exit" ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div
        className={`flex flex-col items-center gap-6 transition-all duration-700 ${
          phase === "enter"
            ? "opacity-0 translate-y-4"
            : phase === "hold"
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-4"
        }`}
      >
        <img
          src="https://storage.readdy-site.link/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/ba4ec6a1-7e9d-44ea-a869-6ae14f8880c1_s-1080x345_v-fs_webp_dad759ce-6815-4676-b25e-6fd91a48c550_small-1.webp?v=bf53e7a2f48e06ded5b156bb3dfa8218"
          alt="OL Company"
          className="w-[200px] md:w-[280px] h-auto object-contain"
        />
      </div>
    </div>
  );
}